import { Type } from 'class-transformer'
import { EnumEntity } from '..'
import { Maintenance } from '@/entities/public/Maintenance'

export class MaintenanceBackupType extends EnumEntity {
  @Type(() => Maintenance)
  maintenances: Maintenance[];
}
